module.exports = __webpack_public_path__ + "media/images/icons/stethoscope-0b3810bdb1f65d921da71725454a5e4c.svg";